module.exports = __webpack_public_path__ + "img/oufu_130x150x12b.prt.9f01d9a7.jpg";